<template>
  <div class="position-relative">
    <div
      class="cta-container flex-grow-1"
      :class="alignmentClassName"
    >
      <h4
        v-if="callToActions.length === 1 && callToActions[0].show_button"
        :class="{'cta-btn--mobile-only': callToActions[0].mobile_only}"
        :style="{color: descriptionColor}"
      >
        {{ callToActions[0].description }}
      </h4>
      <template v-for="action in callToActions">
        <a
          v-if="action.show_button"
          class="btn btn-lg cta-btn"
          :class="[{'cta-btn--mobile-only': action.mobile_only}, buttonClassName]"
          :href="getHref(action)"
          :target="action.url_target"
          @click="clickCta($event, action)"
        >
          {{ action.button_text }}
        </a>
      </template>
      <a
        v-if="salesAssistant"
        type="button"
        class="btn btn-lg cta-btn cta-btn--mobile-only"
        :class="buttonClassName"
        @click="clickSalesAssistant()"
      >
        Chat With {{ salesAssistant.name }}
      </a>
      <a
        v-if="currentVideo && currentVideo.switches.downloadable && currentVideo.switches.download_cta && currentVideo.mp4_url"
        target="_blank"
        :href="currentVideo.mp4_url"
        class="btn btn-lg cta-btn"
        :class="buttonClassName"
      >Download Video</a>
    </div>
    <div
      v-if="shouldShowGateForm"
      class="position-absolute inset-0 cursor-pointer"
      style="z-index: 999;"
      @click="showGateForm()"
    ></div>
  </div>
</template>

<script>
import { is_android, is_small_screen } from '../../../utils'
import { useVideoShow } from '../use-video-show'
import { useFixedHeaderHeight } from './use-fixed-header-height'
import constants from '@/generated/constants.js'

export default {
  name: 'CallToActions',
  props: {
    callToActions: {},
    currentVideo: {},
    alignment: {
      type: String,
      default: 'center'
    },
    descriptionColor: {
      type: String,
      default: constants.GLOBAL.DEFAULT_VIDEO_TITLE_COLOR
    },
    buttonClassName: {
      type: String
    },
    shouldShowGateForm: {
      type: Boolean,
      default: false
    },
    salesAssistant: {
      default: null
    }
  },
  emits: ['click-call-to-action', 'show-gate-form'],
  setup () {
    const { quickConversationRef, isQuickConversationModal } = useVideoShow()
    const { fixedHeaderHeight } = useFixedHeaderHeight()

    const showQuickConversationModal = () => {
      if (quickConversationRef.value && isQuickConversationModal.value) {
        quickConversationRef.value.show()
        return true
      }

      // when the quick conversation modal is not available
      return false
    }

    return {
      showQuickConversationModal,
      fixedHeaderHeight
    }
  },
  computed: {
    alignmentClassName () {
      return `text-${this.alignment}`
    }
  },
  methods: {
    getHref (action) {
      if (!action.url) {
        return 'javascript:;'
      }

      if (action.type === this.constants.App_Models_CallToAction.TYPE_PHONE && action.data && action.sub_type === this.constants.App_Models_CallToAction.SUB_TYPE_SMS && is_android()) {
        return action.url.replace('sms:', 'sms://').replace('&', '?')
      }

      return action.url
    },
    clickCta (event, action) {
      // with the sales assistant floating, the container is not the body
      // when using in the showcase and custom video template, the currentVideo maybe undefined.
      const canScrollWithUrl = this.currentVideo?.switches.layout === this.constants.GLOBAL.VIDEO_LAYOUT_CENTERED &&
        !is_small_screen() &&
        this.salesAssistant

      if (action.url.startsWith('#') && !canScrollWithUrl) {
        event.preventDefault()

        const ctaElement = document.querySelector(action.url)
        if (ctaElement) {
          const ctaTop = ctaElement.getBoundingClientRect().top
          const bodyTop = document.body.getBoundingClientRect().top

          window.scrollTo({
            top: ctaTop - bodyTop - this.fixedHeaderHeight,
            behavior: 'smooth'
          })
        }
      }

      this.$emit('click-call-to-action', action)
    },
    clickSalesAssistant () {
      if (is_small_screen()) {
        this.showQuickConversationModal()
      }
    },
    showGateForm () {
      this.$emit('show-gate-form')
    }
  }
}
</script>

<style lang="scss" scoped>
.cta {
  &-container {
    margin-top: 20px;
  }
  &-btn {
    margin-top: 15px;

    @media (max-width: 768px) {
      display: block;
    }

    &--mobile-only {
      @media (min-width: 768px) {
        display: none;
      }
    }
  }
}

</style>
